





























































































































































































































































































































































































































































































































import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store/types";
import ProjectHeader from "./Organisms/ProjectHeader";
import SplitView from "./Atoms/SplitView/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import MenuBarButton from "@/components/Atoms/MenuBarButton/index.vue";
import EventTimeline from "./Molecules/EventTimeline/index.vue";
import StudentTrendChart from "./Molecules/StudentTrendChart/index.vue";
import OwnOrganizationName from "./Molecules/OwnOrganizationName/index.vue";
import TimelineEventBox from "./Atoms/TimelineEventBox/index.vue";
import { EventTypes } from "./Atoms/TimelineEventBox/types";
import OwnOrganizationSpeechBubble from "./Organisms/OwnOrganizationSpeechBubble";
import CompetitorName from "./Molecules/CompetitorName/index.vue";
import UniversityName from "./Molecules/UniversityName/index.vue";
import UniversitySelectBox from "./Atoms/UniversitySelectBox/index.vue";
import StudentTrendCategorySelectBox from "./Atoms/StudentTrendCategorySelectBox/index.vue";
import CompetitorSpeechBubble from "./Organisms/CompetitorSpeechBubble";
import StudentSpeechBubble from "./Organisms/StudentSpeechBubble";
import CreateEventView from "./Organisms/CreateEventView";
import EditEventView from "./Organisms/EditEventView";
import DeleteEventView from "./Organisms/DeleteEventView";
import ConfirmDestroyView from "./Organisms/ConfirmDestroyView";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import CompetitorFloatingView from "./Organisms/CompetitorFloatingView";
import FollowCompetitorFloatingView from "./Organisms/FollowCompetitorFloatingView/index.vue";
import FollowUniversityFloatingView from "./Organisms/FollowUniversityFloatingView/index.vue";
import UniversityFloatingView from "./Organisms/UniversityFloatingView";
import GraduateYearsLegend from "./Molecules/GraduateYearsLegend/index.vue";
import Draggable from "vuedraggable";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import { PropType } from "vue";
import { isOuterElementClicked } from "@/helpers/vue-helper";
import {
  calculateTimelineHeight,
  calculateSpeechBubblePosition
} from "@/helpers/plan-helper";
import { Data, Methods, Computed, Props } from "./types";
import { sum } from "@/helpers/math-helper";

const COMPETITOR_STYLES = {
  MIN_HEIGHT: 90,
  PADDING_TOP: 0
};

const UNIVERSITY_STYLES = {
  MIN_HEIGHT: 60
};

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ProjectHeader,
    SplitView,
    Heading,
    Body,
    MenuBarButton,
    EventTimeline,
    StudentTrendChart,
    OwnOrganizationName,
    OwnOrganizationSpeechBubble,
    CompetitorName,
    TimelineEventBox,
    CompetitorFloatingView,
    FollowCompetitorFloatingView,
    FollowUniversityFloatingView,
    CompetitorSpeechBubble,
    CreateEventView,
    EditEventView,
    DeleteEventView,
    ConfirmDestroyView,
    LoadingView,
    GraduateYearsLegend,
    UniversityName,
    UniversitySelectBox,
    StudentTrendCategorySelectBox,
    UniversityFloatingView,
    StudentSpeechBubble,
    Draggable,
    Caption
  },
  props: {
    partnerId: {
      type: Number,
      default: undefined
    },
    company: {
      type: Object as PropType<Props["company"]>,
      default: undefined
    },
    companies: {
      type: Array as PropType<Props["companies"]>,
      required: true,
      default: () => []
    },
    plan: {
      type: Object as PropType<Props["plan"]>,
      default: undefined
    },
    competitorEmbeddeds: {
      type: Array as PropType<Props["competitorEmbeddeds"]>,
      required: true
    },
    studentEmbeddeds: {
      type: Array as PropType<Props["studentEmbeddeds"]>,
      required: true
    },
    competitorErrors: {
      type: Array as PropType<Props["competitorErrors"]>,
      required: true
    },
    selectedRecruitmentEvent: {
      type: Object as PropType<Props["selectedRecruitmentEvent"]>,
      default: undefined
    },
    selectedCompetitorEvent: {
      type: Object as PropType<Props["selectedCompetitorEvent"]>,
      default: undefined
    },
    selectedStudentEvent: {
      type: Object as PropType<Props["selectedStudentEvent"]>,
      default: undefined
    },
    selectedUniversityId: {
      type: Number,
      default: undefined
    },
    selectedStudentTrendCategory: {
      type: String as PropType<Props["selectedStudentTrendCategory"]>,
      default: "MEMBER_REGISTRATION_COUNT"
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    distinctUniversities: {
      type: Array as PropType<Props["distinctUniversities"]>,
      required: true
    },
    studentJobHuntingTrendCollection: {
      type: Object as PropType<Props["studentJobHuntingTrendCollection"]>,
      default: undefined
    },
    planSettings: {
      type: Object as PropType<Props["planSettings"]>,
      required: true
    },
    existCredit: {
      type: Boolean as PropType<Props["existCredit"]>,
      default: false
    },
    selectedGraduateYears: {
      type: Array as PropType<Props["selectedGraduateYears"]>,
      default: () => []
    }
  },
  data() {
    return {
      scrollOffsetOfCompetitor: 0,
      defaultSectionMinWidth: 165,
      scrollTimerId: -1,
      presentScrollArea: null,
      HEIGHT_OF_GRADUATE_YEARS_LEGEND: 60,
      HEIGHT_OF_TIMELINE_NAME_LABEL: 24,
      HEIGHT_OF_STUDENT_TREND_CHART: window.innerHeight * 0.2,
      EventTypes: EventTypes,
      addedCompanies: undefined,
      addedUniversity: undefined
    };
  },
  computed: {
    ...mapState<RootState>({
      isCreateEventViewVisible: (state: RootState) =>
        state.pages.plan.isCreateEventViewVisible,
      isEditEventViewVisible: (state: RootState) =>
        state.pages.plan.isEditEventViewVisible,
      isDeleteEventViewVisible: (state: RootState) =>
        state.pages.plan.isDeleteEventViewVisible,
      isConfirmDestroyViewVisible: (state: RootState) =>
        state.pages.plan.isConfirmDestroyViewVisible,
      timeLineMagnification: (state: RootState) =>
        state.pages.plan.planSettings.timeLineMagnification,
      isCompetitorViewVisible: (state: RootState) =>
        state.pages.plan.isCompetitorViewVisible,
      isUniversityViewVisible: (state: RootState) =>
        state.pages.plan.isUniversityViewVisible
    }),
    graduateYear() {
      if (!this.plan) {
        return;
      }
      return this.plan.graduate_year;
    },
    previousGraduateYear() {
      if (!this.graduateYear) {
        return;
      }
      return {
        oneYearAgo: this.graduateYear - 1,
        twoYearsAgo: this.graduateYear - 2
      };
    },
    lastOfGraduateYear() {
      return this.plan ? this.plan.planEndDate.year() : -1;
    },
    planPeriod() {
      if (!this.plan) {
        return "";
      }
      return `${this.plan.planStartDate.year()}年${this.plan.planStartDate.month() +
        1}月から${this.plan.planEndDate.year()}年${this.plan.planEndDate.month() +
        1}月`;
    },
    projectPeriodObject() {
      return {
        planStartDate: this.plan.planStartDate,
        planEndDate: this.plan.planEndDate
      };
    },
    planName() {
      if (!this.plan) {
        return "";
      }
      return this.plan.name;
    },
    recruitmentEvents() {
      if (
        !this.plan ||
        !this.selectedGraduateYears ||
        !this.graduateYear ||
        !this.selectedGraduateYears.includes(this.graduateYear)
      ) {
        return [];
      }
      return this.plan.recruitment_events_with_position;
    },
    selectedEventElement() {
      if (this.selectedRecruitmentEvent) {
        return document.querySelector(
          `[data-ownOrganizationEventId='${this.selectedRecruitmentEvent.id}']`
        );
      } else if (this.selectedCompetitorEvent) {
        return document.querySelector(
          `[data-othersEventId='${this.selectedCompetitorEvent.id}']`
        );
      } else if (this.selectedStudentEvent) {
        return document.querySelector(
          `[data-studentEventId='${this.selectedStudentEvent.id}']`
        );
      }
      return null;
    },
    selectedSpeechBubbleElement() {
      if (this.selectedRecruitmentEvent) {
        return (this.$refs.ownOrganizationSpeechBubble as Vue)
          .$el as HTMLElement;
      } else if (this.selectedCompetitorEvent) {
        return (this.$refs.competitorSpeechBubble as Vue).$el as HTMLElement;
      } else if (this.selectedStudentEvent) {
        return (this.$refs.studentSpeechBubble as Vue).$el as HTMLElement;
      }
      return null;
    },
    computeSelectedUniversityId: {
      get() {
        return this.selectedUniversityId;
      },
      set(val) {
        this.$emit("updateSelectedUniversityId", val);
      }
    },
    computeSelectedStudentTrendCategory: {
      get() {
        return this.selectedStudentTrendCategory;
      },
      set(val) {
        this.$emit("updateSelectedStudentTrendCategory", val);
      }
    },
    computeSelectedGraduateYears: {
      get() {
        return this.selectedGraduateYears;
      },
      set(val) {
        this.$emit("updateSelectedGraduateYears", val);
      }
    },
    ownEventTimelineHeight() {
      return calculateTimelineHeight(
        this.recruitmentEvents,
        COMPETITOR_STYLES.MIN_HEIGHT
      );
    },
    eventSpacerHeight() {
      if (!this.competitorEmbeddeds.length) {
        return (
          this.HEIGHT_OF_TIMELINE_NAME_LABEL + COMPETITOR_STYLES.PADDING_TOP
        );
      }
      return this.HEIGHT_OF_TIMELINE_NAME_LABEL;
    },
    competitorEventTimelineHeight() {
      if (!this.plan) {
        return -1;
      }

      const competitorsTimelineHeightList = this.plan.competitors.reduce<{
        [competitorId: number]: number;
      }>((accumulator, competitor) => {
        const competitorEmbedded = this.competitorEmbeddeds.find(
          _competitorEmbedded => {
            return _competitorEmbedded.id === competitor.id;
          }
        );
        if (competitorEmbedded) {
          accumulator[competitor.id] = calculateTimelineHeight(
            competitorEmbedded.events,
            COMPETITOR_STYLES.MIN_HEIGHT
          );
        } else {
          accumulator[competitor.id] = COMPETITOR_STYLES.MIN_HEIGHT;
        }
        return accumulator;
      }, {});

      const height = sum([
        ...Object.values(competitorsTimelineHeightList),
        this.HEIGHT_OF_GRADUATE_YEARS_LEGEND
      ]);
      return height;
    },
    universityEventTimelineHeight() {
      if (!this.plan) {
        return -1;
      }

      const studentTimelineHeightList = this.plan.student_segments.reduce<{
        [studentId: number]: number;
      }>((accumulator, student) => {
        const studentEmbedded = this.studentEmbeddeds.find(_studentEmbedded => {
          return _studentEmbedded.id === student.id;
        });
        if (studentEmbedded) {
          accumulator[student.id] = calculateTimelineHeight(
            studentEmbedded.events,
            UNIVERSITY_STYLES.MIN_HEIGHT
          );
        } else {
          accumulator[student.id] = UNIVERSITY_STYLES.MIN_HEIGHT;
        }
        return accumulator;
      }, {});

      const height = sum([
        ...Object.values(studentTimelineHeightList),
        this.HEIGHT_OF_GRADUATE_YEARS_LEGEND
      ]);
      return height;
    },
    bottomPaddingStyleForNamesList() {
      return {
        "padding-bottom": `${this.HEIGHT_OF_GRADUATE_YEARS_LEGEND}px`
      };
    },
    competitorTimelineWidth() {
      const competitorEventTimelineRef = this.$refs
        .competitorEventTimeline as Vue;
      return (
        competitorEventTimelineRef && competitorEventTimelineRef.$el.clientWidth
      );
    }
  },
  watch: {
    selectedRecruitmentEvent(value) {
      if (value) {
        Vue.nextTick(this.updateSpeechBubblePosition);
      }
    },
    selectedCompetitorEvent(value) {
      if (value) {
        Vue.nextTick(this.updateSpeechBubblePosition);
      }
    },
    selectedStudentEvent(value) {
      if (value) {
        Vue.nextTick(this.updateSpeechBubblePosition);
      }
    }
  },
  mounted() {
    window.addEventListener("click", this.handleWindowClick);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleWindowClick);
  },
  methods: {
    eventTypeYear(startYear, startMonth) {
      return startMonth <= 3 ? startYear - 1 : startYear;
    },
    universityEventType(event) {
      const startYear = event?.start_at?.year;
      const startMonth = event?.start_at?.month;
      if (!this.graduateYear || !startYear || !startMonth)
        return EventTypes.TwoYearAgoEvent;
      const targetEventTypeYear = this.eventTypeYear(startYear, startMonth);
      return this.graduateYear - targetEventTypeYear <= 2
        ? EventTypes.ThisYearEvent
        : this.graduateYear - targetEventTypeYear === 3
        ? EventTypes.OneYearAgoEvent
        : EventTypes.TwoYearAgoEvent;
    },
    handleDragCompetitorEnd({ oldIndex, newIndex }) {
      this.$emit("updateCompetitorsOrder", { oldIndex, newIndex });
    },
    handleDragUniversitiesEnd({ oldIndex, newIndex }) {
      this.$emit("updateUniversitiesOrder", { oldIndex, newIndex });
    },
    handleCompetitorMenuClick(value, competitor) {
      switch (value) {
        case "delete": {
          this.$emit(
            "competitorDeleteEvent",
            this.partnerId,
            this.plan.id,
            competitor
          );
          break;
        }
        case "reload": {
          break;
        }
      }
    },
    handleUniversityMenuClick(
      value,
      studentId,
      universityName,
      universityCourse
    ) {
      switch (value) {
        case "edit": {
          this.updateUniversityObject = {
            name: universityName,
            course: universityCourse,
            studentId: studentId,
            update: true
          };
          this.$emit("universityFloatingView");
          break;
        }
        case "delete": {
          this.$emit(
            "universityDeleteEvent",
            this.partnerId,
            this.plan.id,
            studentId
          );
          break;
        }
      }
    },
    hasCompetitorEmbedded(competitor) {
      return this.competitorEmbeddeds.some(competitorEmbedded => {
        return competitorEmbedded.id === competitor.id;
      });
    },
    hasStudentEmbedded(student) {
      return this.studentEmbeddeds.some((studentEmbedded: any) => {
        return studentEmbedded.id === student.id;
      });
    },
    getCompetitorEmbedded(competitor) {
      return this.competitorEmbeddeds.find(competitorEmbedded => {
        return competitorEmbedded.id === competitor.id;
      });
    },
    getCompetitorEmbeddedEvents(competitor) {
      const embeddedEvents = this.getCompetitorEmbedded(competitor)?.events;
      return embeddedEvents?.filter(
        event =>
          event.graduate_year &&
          this.selectedGraduateYears.includes(event.graduate_year)
      );
    },
    checkHasCompetitorEmbeddedEvents(competitor) {
      const competitorEmbedded = this.getCompetitorEmbedded(competitor);
      return competitorEmbedded && !!competitorEmbedded.events.length;
    },
    getStudentEmbedded(student) {
      return this.studentEmbeddeds.find((studentEmbedded: any) => {
        return studentEmbedded.id === student.id;
      });
    },
    getStudentEmbeddedEvents(student) {
      const embedded = this.getStudentEmbedded(student);
      if (!embedded || !embedded.events) return [];
      const embeddedEvents = embedded.events.filter(event => {
        if (
          !this.graduateYear ||
          !event?.start_at?.year ||
          !event?.start_at?.month
        )
          return false;
        const targetEventTypeYear = this.eventTypeYear(
          event?.start_at?.year,
          event?.start_at?.month
        );
        const targetGraduateYear =
          this.graduateYear - targetEventTypeYear <= 2
            ? this.graduateYear
            : this.graduateYear - targetEventTypeYear === 3
            ? this.graduateYear - 1
            : this.graduateYear - 2;
        return this.selectedGraduateYears.includes(targetGraduateYear);
      });
      return embeddedEvents || [];
    },
    getStyleFromPosition(position) {
      const isVisible = position.width > 0;
      return {
        display: isVisible ? "block" : "none",
        width: `${position.width}px`,
        height: `${position.height}px`,
        position: "absolute",
        top: `${position.y}px`,
        left: `${position.x}px`
      };
    },
    getCompetitorNameHeight(competitor) {
      let timelineHeight = this.getCompetitorEventHeight(competitor);
      return timelineHeight;
    },
    getCompetitorEventHeight(competitor) {
      const competitorEmbedded = this.getCompetitorEmbedded(competitor);
      if (!competitorEmbedded) {
        return COMPETITOR_STYLES.MIN_HEIGHT;
      }
      return calculateTimelineHeight(
        competitorEmbedded.events,
        COMPETITOR_STYLES.MIN_HEIGHT
      );
    },
    getStudentNameHeight(student) {
      let timelineHeight = this.getStudentEventHeight(student);
      return timelineHeight;
    },
    getStudentEventHeight(student) {
      const studentEmbedded = this.getStudentEmbedded(student);
      if (!studentEmbedded) {
        return UNIVERSITY_STYLES.MIN_HEIGHT;
      }
      return calculateTimelineHeight(
        studentEmbedded.events,
        UNIVERSITY_STYLES.MIN_HEIGHT
      );
    },
    updateSpeechBubblePosition() {
      if (!this.selectedEventElement || !this.selectedSpeechBubbleElement) {
        return;
      }
      const position = calculateSpeechBubblePosition(
        this.selectedEventElement,
        this.selectedSpeechBubbleElement
      );
      this.selectedSpeechBubbleElement.focus();
      this.$emit("updateSpeechBubble", position);
    },
    detectOuterEventClicked(event) {
      if (!this.selectedEventElement || !this.selectedSpeechBubbleElement) {
        return false;
      }
      return isOuterElementClicked(
        event.target,
        this.selectedEventElement,
        this.selectedSpeechBubbleElement
      );
    },
    getCompetitorState(companyId: number) {
      const isError = this.competitorErrors.some(error => {
        return error.companyId === companyId;
      });
      if (isError) {
        return "error";
      }
      const hasEvent = this.competitorEmbeddeds.some(competitor => {
        return competitor.company.id === companyId;
      });
      if (!hasEvent) {
        return "loading";
      }
      return "default";
    },
    // getStudentState(companyId: number) {
    //   const isError = this.competitorErrors.some(error => {
    //     return error.companyId === companyId;
    //   });
    //   if (isError) {
    //     return "error";
    //   }
    //   const hasEvent = this.competitorEmbeddeds.some(competitor => {
    //     return competitor.company.id === companyId;
    //   });
    //   if (!hasEvent) {
    //     return "loading";
    //   }
    //   return "default";
    // },
    handleWindowClick(event) {
      if (this.detectOuterEventClicked(event)) {
        this.$emit("clickOuterEvent");
      }
    },
    handleOwnOrganizationEventClick(eventId) {
      this.$emit("clickOwnOrganizationEvent", eventId);
    },
    handleCreatedOwnOrganizationEvent() {
      this.$emit("createdEvent");
    },
    handleDeletedOwnOrganizationEvent() {
      this.$emit("deletedEvent");
    },
    handleCloseCompetitorFloatingView(addedCompanies) {
      this.addedCompanies = addedCompanies;
    },
    handleCloseUniversityFloatingView(addedUniversity) {
      this.addedUniversity = addedUniversity;
    },
    handleCloseFollowCompetitorFloatingView() {
      this.addedCompanies = undefined;
    },
    handleCloseFollowUniversityFloatingView() {
      this.addedUniversity = undefined;
    },
    handleCompetitorEventClick(competitor, event) {
      this.$emit("clickCompetitorEvent", {
        competitor,
        event
      });
    },
    handleStudentEventClick(student, event) {
      this.$emit("clickStudentEvent", {
        student,
        event
      });
    },
    handleCompetitorFloatingView() {
      this.$emit("competitorFloatingView");
    },
    handleUniversityFloatingView() {
      this.updateUniversityObject = {
        name: "",
        course: "UNSPECIFIED",
        studentId: 0,
        update: false
      };
      this.$emit("universityFloatingView");
    },
    handleScrollCompetitorNames(event) {
      if (!event.target || !(event.target instanceof Element)) {
        return;
      }

      this.handleScroll({
        scrollArea: "COMPETITOR_LIST",
        event
      });
    },
    handleScrollUniversityNames(event) {
      if (!event.target || !(event.target instanceof Element)) {
        return;
      }

      this.handleScroll({
        scrollArea: "UNIVERSITY_LIST",
        event
      });
    },
    setPresentScrollArea(scrollArea) {
      if (this.scrollTimerId > -1) {
        clearTimeout(this.scrollTimerId);
      }
      this.presentScrollArea = scrollArea;
      this.scrollTimerId = setTimeout(() => {
        this.scrollTimerId = -1;
        this.presentScrollArea = null;
      }, 100);
    },
    handleScroll({ scrollArea, event }) {
      if (!event.target || !(event.target instanceof Element)) return;

      if (this.presentScrollArea && this.presentScrollArea !== scrollArea)
        return;

      this.setPresentScrollArea(scrollArea);

      const { scrollLeft, scrollTop } = event.target;

      const ownEvent = this.$refs.ownEventTimeline as Vue;
      const competitorEvent = this.$refs.competitorEventTimeline as Vue;
      const universityEvent = this.$refs.universityEventTimeline as Vue;
      const studentTrend = this.$refs.studentTrendTimeline as Vue;
      const extra = this.$refs.extraTimeline as Vue;

      const ownEventTimeline = ownEvent.$refs.timeline as Element;
      const ownEventTimelineAxis = ownEvent.$refs.axis as Element;
      const competitorNameList = this.$refs.competitorNamesScroller as Element;
      const competitorEventTimeline = competitorEvent.$refs.timeline as Element;
      const competitorEventTimelineAxis = competitorEvent.$refs.axis as Element;
      const universityNameList = this.$refs.universityNamesScroller as Element;
      const universityEventTimeline = universityEvent.$refs.timeline as Element;
      const universityEventTimelineAxis = universityEvent.$refs.axis as Element;
      const studentTrendTimeline = studentTrend.$refs.timeline as Element;
      const studentTrendTimelineAxis = studentTrend.$refs.axis as Element;
      const extraTimeline = extra.$refs.timeline as Element;

      switch (scrollArea) {
        case "OWN_EVENT_TIMELINE":
          ownEventTimelineAxis.scrollLeft = scrollLeft;
          competitorEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimelineAxis.scrollLeft = scrollLeft;
          universityEventTimeline.scrollLeft = scrollLeft;
          universityEventTimelineAxis.scrollLeft = scrollLeft;
          studentTrendTimeline.scrollLeft = scrollLeft;
          studentTrendTimelineAxis.scrollLeft = scrollLeft;
          extraTimeline.scrollLeft = scrollLeft;
          break;
        case "OWN_EVENT_TIMELINE_AXIS":
          ownEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimelineAxis.scrollLeft = scrollLeft;
          universityEventTimeline.scrollLeft = scrollLeft;
          universityEventTimelineAxis.scrollLeft = scrollLeft;
          studentTrendTimeline.scrollLeft = scrollLeft;
          studentTrendTimelineAxis.scrollLeft = scrollLeft;
          extraTimeline.scrollLeft = scrollLeft;
          break;

        case "COMPETITOR_LIST":
          competitorEventTimeline.scrollTop = scrollTop;
          break;
        case "COMPETITOR_EVENT_TIMELINE":
          ownEventTimelineAxis.scrollLeft = scrollLeft;
          ownEventTimeline.scrollLeft = scrollLeft;
          competitorNameList.scrollTop = scrollTop;
          competitorEventTimelineAxis.scrollLeft = scrollLeft;
          universityEventTimeline.scrollLeft = scrollLeft;
          universityEventTimelineAxis.scrollLeft = scrollLeft;
          studentTrendTimeline.scrollLeft = scrollLeft;
          studentTrendTimelineAxis.scrollLeft = scrollLeft;
          extraTimeline.scrollLeft = scrollLeft;
          break;
        case "COMPETITOR_EVENT_TIMELINE_AXIS":
          ownEventTimelineAxis.scrollLeft = scrollLeft;
          ownEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimeline.scrollLeft = scrollLeft;
          universityEventTimeline.scrollLeft = scrollLeft;
          universityEventTimelineAxis.scrollLeft = scrollLeft;
          studentTrendTimeline.scrollLeft = scrollLeft;
          studentTrendTimelineAxis.scrollLeft = scrollLeft;
          extraTimeline.scrollLeft = scrollLeft;
          break;

        case "UNIVERSITY_LIST":
          universityEventTimeline.scrollTop = scrollTop;
          break;
        case "UNIVERSITY_EVENT_TIMELINE":
          ownEventTimelineAxis.scrollLeft = scrollLeft;
          ownEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimelineAxis.scrollLeft = scrollLeft;
          universityNameList.scrollTop = scrollTop;
          universityEventTimelineAxis.scrollLeft = scrollLeft;
          studentTrendTimeline.scrollLeft = scrollLeft;
          studentTrendTimelineAxis.scrollLeft = scrollLeft;
          extraTimeline.scrollLeft = scrollLeft;
          break;
        case "UNIVERSITY_EVENT_TIMELINE_AXIS":
          ownEventTimelineAxis.scrollLeft = scrollLeft;
          ownEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimelineAxis.scrollLeft = scrollLeft;
          universityEventTimeline.scrollLeft = scrollLeft;
          studentTrendTimeline.scrollLeft = scrollLeft;
          studentTrendTimelineAxis.scrollLeft = scrollLeft;
          extraTimeline.scrollLeft = scrollLeft;
          break;

        case "STUDENT_TREND_TIMELINE":
          ownEventTimelineAxis.scrollLeft = scrollLeft;
          ownEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimelineAxis.scrollLeft = scrollLeft;
          universityEventTimeline.scrollLeft = scrollLeft;
          universityEventTimelineAxis.scrollLeft = scrollLeft;
          studentTrendTimelineAxis.scrollLeft = scrollLeft;
          extraTimeline.scrollLeft = scrollLeft;
          break;
        case "STUDENT_TREND_TIMELINE_AXIS":
          ownEventTimelineAxis.scrollLeft = scrollLeft;
          ownEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimelineAxis.scrollLeft = scrollLeft;
          universityEventTimeline.scrollLeft = scrollLeft;
          universityEventTimelineAxis.scrollLeft = scrollLeft;
          studentTrendTimeline.scrollLeft = scrollLeft;
          extraTimeline.scrollLeft = scrollLeft;
          break;
        case "EXTRA_TIMELINE":
          ownEventTimelineAxis.scrollLeft = scrollLeft;
          ownEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimeline.scrollLeft = scrollLeft;
          competitorEventTimelineAxis.scrollLeft = scrollLeft;
          universityEventTimeline.scrollLeft = scrollLeft;
          universityEventTimelineAxis.scrollLeft = scrollLeft;
          studentTrendTimeline.scrollLeft = scrollLeft;
          studentTrendTimelineAxis.scrollLeft = scrollLeft;
          break;
      }
    },
    handleClickOwnEventToggle() {
      this.$emit("clickOwnEventToggle");
    },
    handleClickCompetitorEventToggle() {
      this.$emit("clickCompetitorEventToggle");
    },
    handleClickUniversityEventToggle() {
      this.$emit("clickUniversityEventToggle");
    },
    handleClickStudentTrendToggle() {
      this.$emit("clickStudentTrendToggle");
    }
  }
});
